var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "lateral-menu" } },
    [
      _c("router-link", { attrs: { to: "/" } }, [
        _c("img", {
          staticClass: "image",
          attrs: { src: require("@/assets/gps_logo.png"), width: "270px" },
        }),
      ]),
      _c("hr", { staticClass: "is-marginless" }),
      _c(
        "b-menu",
        { attrs: { activable: false } },
        [
          _vm.user.group.type === "CUSTOMER"
            ? _c(
                "b-menu-list",
                { attrs: { label: _vm.$t("sidebar.customer") } },
                [
                  _vm.authorize("/dashboard/:id")
                    ? _c(
                        "b-menu-item",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function (props) {
                                  return [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "chart-bar",
                                        type: "is-blue",
                                        size: "is-small",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "has-text-grey" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("sidebar.dashboard"))
                                        ),
                                      ]
                                    ),
                                    _c("b-icon", {
                                      staticClass: "is-pulled-right",
                                      attrs: {
                                        icon: props.expanded
                                          ? "caret-down"
                                          : "caret-up",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2399341745
                          ),
                        },
                        _vm._l(_vm.allDashboardsName, function (item, index) {
                          return _c(
                            "b-menu-item",
                            {
                              key: index,
                              attrs: {
                                tag: "router-link",
                                to: {
                                  name: "dashboard",
                                  params: { id: index },
                                },
                              },
                            },
                            [
                              _c("template", { slot: "label" }, [
                                _c("span", { staticClass: "has-text-grey" }, [
                                  _vm._v(
                                    _vm._s(item.name.replaceAll("_", " "))
                                  ),
                                ]),
                              ]),
                            ],
                            2
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.authorize("/maps")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/maps" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "map-marker-alt",
                                  type: "is-red",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.map"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/iotMap")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/iotMap" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "map-marker-alt",
                                  type: "is-blue",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(" IoT Map (Admin) "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/crateTrack")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/crateTrack" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "map-marker-alt",
                                  type: "is-red",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(" IoT Map (Client) "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/deliveries")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/deliveries" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "truck-moving",
                                  type: "is-brown",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.deliveries"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/stock")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/stock" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "cube",
                                  type: "is-green",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.stock"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/scan-stock")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/scan-stock" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "barcode",
                                  type: "is-green",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.scan_stock"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/scan-shipping")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/scan-shipping" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "barcode",
                                  type: "is-green",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.scan_shipping"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/scan-mvt")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/scan-mvt" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "barcode",
                                  type: "is-green",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.scan_mvt"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/shipping")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/shipping" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "truck",
                                  type: "is-purple",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.shipping"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/collections")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/collections" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "truck-loading",
                                  type: "is-orange",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.collections"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/download")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/download" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "download",
                                  type: "is-pink",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.download"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/shippingManagement")
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "router-link",
                            to: "/shippingManagement",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "dolly-flatbed",
                                  type: "is-yellow",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("sidebar.shipping_management"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/scan-users")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/scan-users" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "portrait",
                                  type: "is-info",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.scan_users"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.user.group.type === "END USER"
            ? _c(
                "b-menu-list",
                { attrs: { label: _vm.$t("sidebar.consignee") } },
                [
                  _vm.authorize("/enduser/pickup-management")
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "router-link",
                            to: "/enduser/pickup-management",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "envelope",
                                  type: "is-purple",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("sidebar.pickup_management"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/enduser/stock")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/enduser/stock" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "cube",
                                  type: "is-green",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.stock"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/enduser/collections")
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "router-link",
                            to: "/enduser/collections",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "truck-loading",
                                  type: "is-orange",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.collections"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }